export default __webpack_public_path__ + "static/media/main_4.ed905f3f.jpeg";